// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"/build/js/main.script": 0,
	"build/css/main.style": 0,
	"components/block--hero-image--overlay/block--hero-image--overlay": 0,
	"components/block--frontpage/block--frontpage": 0,
	"components/block--block-content--type--parallax-block/block--block-content--type--parallax-block": 0,
	"components/accordion/accordion": 0,
	"build/css/component/layout-builder/layout-builder": 0,
	"components/views-view-unformatted--all-product-images--block-1/views-view-unformatted--all-product-images--block-1": 0,
	"components/views-view--unformatted/views-view--unformatted": 0,
	"components/views-view--unformatted--nrewood-categories--block-1/views-view--unformatted--nrewood-categories--block-1": 0,
	"components/views-view--unformatted--accordion-test--block-1/views-view--unformatted--accordion-test--block-1": 0,
	"components/testimonial-carousel/testimonial-carousel": 0,
	"components/region/region": 0,
	"components/region-footer/region-footer": 0,
	"components/page/page": 0,
	"components/page-navigation/page-navigation": 0,
	"components/page-footer/page-footer": 0,
	"components/page-content/page-content": 0,
	"components/page-content--front/page-content--front": 0,
	"components/page-content--about/page-content--about": 0,
	"components/page--front/page": 0,
	"components/node/node": 0,
	"components/node--products/node--products": 0,
	"components/node--9/node--9": 0,
	"components/node--37--full/node--37--full": 0,
	"components/navbar/navbar": 0,
	"components/navbar-brand/navbar-brand": 0,
	"components/nav/nav": 0,
	"components/modal/modal": 0,
	"components/image/image": 0,
	"components/heading/heading": 0,
	"components/heading-footer/heading-footer": 0,
	"components/field/field": 0,
	"components/field-image--hero/field-image--hero": 0,
	"components/card/card": 0,
	"components/block/block": 0,
	"components/block-workshop/block-workshop": 0,
	"components/block-footer/block-footer": 0,
	"components/block-aboutnialldesktop/block-aboutnialldesktop": 0,
	"components/block--nrewood7-cavillchairanimation/block--nrewood7-cavillchairanimation": 0,
	"components/block--modal/block": 0
};

// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };

// install a JSONP callback for chunk loading
var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
	var chunkIds = data[0];
	var moreModules = data[1];
	var runtime = data[2];
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunknrewood7"] = self["webpackChunknrewood7"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));